module.exports = require('./readable').Transform



//////////////////
// WEBPACK FOOTER
// /home/ec2-user/Source/aws-lex-web-ui/node_modules/readable-stream/transform.js
// module id = 423
// module chunks = 0